let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("idH5H")]).then(() => parcelRequire('a7dE6'));